import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const GalleryViewFill = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M7.5 2H2.5V6C2.5 6.55228 2.94772 7 3.5 7L6.5 7C7.05228 7 7.5 6.55228 7.5 6V2Z" fill="white" />
        <path d="M14.5 2H9.5V6C9.5 6.55228 9.94772 7 10.5 7L13.5 7C14.0523 7 14.5 6.55228 14.5 6V2Z" fill="white" />
        <path d="M7.5 9H2.5V13C2.5 13.5523 2.94772 14 3.5 14L6.5 14C7.05228 14 7.5 13.5523 7.5 13V9Z" fill="white" />
        <path
          d="M14.5 9H9.5V13C9.5 13.5523 9.94772 14 10.5 14L13.5 14C14.0523 14 14.5 13.5523 14.5 13V9Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 1.5C2.44772 1.5 2 1.94772 2 2.5V6.5C2 7.05228 2.44772 7.5 3 7.5H7C7.55228 7.5 8 7.05228 8 6.5V2.5C8 1.94772 7.55228 1.5 7 1.5H3ZM3 2.5L7 2.5V6.5H3V2.5ZM3 8.5C2.44772 8.5 2 8.94772 2 9.5V13.5C2 14.0523 2.44772 14.5 3 14.5H7C7.55228 14.5 8 14.0523 8 13.5V9.5C8 8.94772 7.55228 8.5 7 8.5H3ZM3 9.5H7V13.5H3V9.5ZM9 2.5C9 1.94772 9.44772 1.5 10 1.5H14C14.5523 1.5 15 1.94772 15 2.5V6.5C15 7.05228 14.5523 7.5 14 7.5H10C9.44772 7.5 9 7.05228 9 6.5V2.5ZM14 2.5L10 2.5V6.5H14V2.5ZM10 8.5C9.44772 8.5 9 8.94772 9 9.5V13.5C9 14.0523 9.44772 14.5 10 14.5H14C14.5523 14.5 15 14.0523 15 13.5V9.5C15 8.94772 14.5523 8.5 14 8.5H10ZM10 9.5H14V13.5H10V9.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default GalleryViewFill
